<template>
  <div
    class="prompt-highscore"
  >
    <div class="prompt-highscore-title">
      <span class="twitch-icon"><TwitchSvg /></span>
      {{ highscore.title }}
    </div>
    <ol
      v-if="highscore.entries.length"
      class="prompt-highscore-list"
    >
      <li
        v-for="(entry, idx) in highscore.entries"
        :key="idx"
        class="prompt-highscore-list-entry"
      >
        <div class="prompt-highscore-line">
          <span class="prompt-highscore-name">{{ entry.name }}</span>
          <span class="prompt-highscore-count">{{ entry.count }}</span>
        </div>
      </li>
    </ol>
    <div v-else>
      Nothing prompted so far.
      <br>
      <br>
      Use the ✨Episode Topic✨ channel point reward for 100 points
      to create a prompt!
    </div>
  </div>
</template>
<script setup lang="ts">
import { Highscore } from '../../../../common/src/Types'
import TwitchSvg from './TwitchSvg.vue'

defineProps<{
  highscore: Highscore,
}>()
</script>
